import { render } from "./detailsTable.vue?vue&type=template&id=bde3f75a"
import script from "./detailsTable.vue?vue&type=script&lang=js"
export * from "./detailsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__